<template>
  <div class="vf-form-field" :data-field-type="field.dataType">
    <label class="vf-form-field-label">
      {{ field.fieldName }}
      <span v-if="field.required" class="required-indicator">*</span>
    </label>

    <div class="vf-form-field-content">
      <div class="datetime-inputs">
        <input
          v-if="field.includeDate"
          type="date"
          v-model="dateValue"
          @input="updateFieldValue"
          class="form-control"
          :name="dateFieldName"
          :required="field.required"
          :class="{ 'datetime-only': !field.includeTime }" />

        <input
          v-if="field.includeTime"
          type="time"
          v-model="timeValue"
          @input="updateFieldValue"
          class="form-control"
          :name="timeFieldName"
          :required="field.required"
          :class="{ 'datetime-only': !field.includeDate }" />
      </div>

      <div v-if="field.description" class="vf-form-field-description" v-html="textToHtml(field.description)"></div>
    </div>
  </div>
</template>

<script>
  import { buildFieldName, textToHtml } from '../../Forms/form-helper.js';
  export default {
    name: 'DateTimeFieldRenderer',
    props: {
      field: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        dateFieldName : buildFieldName(this.field) + '_date',
        timeFieldName : buildFieldName(this.field) + '_time',
        dateValue: '',
        timeValue: ''
      };
    },
    mounted() {
      // Parse existing value if present
      if (this.field.value) {
        const date = new Date(this.field.value);
        if (!isNaN(date)) {
          if (this.field.includeDate) {
            this.dateValue = date.toISOString().split('T')[0];
          }
          if (this.field.includeTime) {
            this.timeValue = date.toTimeString().slice(0, 5);
          }
        }
      }
    },
    methods: {
      textToHtml,
      updateFieldValue() {
        let combinedValue = '';

        if (this.field.includeDate && this.field.includeTime) {
          // Combine date and time
          if (this.dateValue && this.timeValue) {
            combinedValue = `${this.dateValue}T${this.timeValue}`;
          }
        } else if (this.field.includeDate) {
          combinedValue = this.dateValue;
        } else if (this.field.includeTime) {
          combinedValue = this.timeValue;
        }

        this.field.value = combinedValue;
      }      
    },
  };
</script>

<style scoped>
  .vf-field {
    margin-bottom: 20px;
  }

  .vf-field-label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .vf-field-description {
    color: #6c757d;
    font-size: 0.9em;
    margin-bottom: 8px;
  }

  .required-indicator {
    color: #d9534f;
    margin-left: 3px;
  }

  .datetime-inputs {
    display: flex;
    gap: 10px;
  }

  .datetime-inputs input {
    flex: 1;
  }

  .datetime-only {
    max-width: 200px;
  }
</style>
